import { ChevronLeftIcon, ChevronRightIcon, ChevronsLeftIcon, ChevronsRightIcon } from "lucide-react";
import * as React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
type PaginationProps = {
  currentPage: number;
  /** Omit for cursor-based lists whose page count is unknown; pass `hasNextPage` instead. */
  totalPages?: number;
  onPageChange: (page: number) => void;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
  onNextPageHover?: () => void;
  showFirstLast?: boolean;
  showTextLabels?: boolean;
  className?: string;
};
export function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  hasPreviousPage = currentPage > 1,
  hasNextPage = totalPages !== undefined && currentPage < totalPages,
  onNextPageHover,
  showFirstLast = false,
  showTextLabels = false,
  className
}: PaginationProps) {
  const buttonSize = showTextLabels ? "sm" : "icon-sm";
  return <nav aria-label="Paginação" className={cn("flex items-center gap-2", className)}>
      {showFirstLast && <Button className="hidden lg:flex" disabled={!hasPreviousPage} onClick={() => onPageChange(1)} size="icon-sm" variant="outline">
          <span className="sr-only">Ir para primeira página</span>
          <ChevronsLeftIcon aria-hidden="true" />
        </Button>}
      <Button disabled={!hasPreviousPage} onClick={() => onPageChange(currentPage - 1)} size={buttonSize} variant="outline">
        <ChevronLeftIcon aria-hidden="true" />
        {showTextLabels ? "Anterior" : <span className="sr-only">Ir para página anterior</span>}
      </Button>
      <span className="text-xs/relaxed font-medium whitespace-nowrap">
        Página {currentPage}
        {totalPages === undefined ? null : ` de ${totalPages}`}
      </span>
      <Button disabled={!hasNextPage} onClick={() => onPageChange(currentPage + 1)} onMouseEnter={onNextPageHover} size={buttonSize} variant="outline">
        {showTextLabels ? "Próxima" : <span className="sr-only">Ir para próxima página</span>}
        <ChevronRightIcon aria-hidden="true" />
      </Button>
      {showFirstLast && <Button className="hidden lg:flex" disabled={!hasNextPage} onClick={() => totalPages !== undefined && onPageChange(totalPages)} size="icon-sm" variant="outline">
          <span className="sr-only">Ir para última página</span>
          <ChevronsRightIcon aria-hidden="true" />
        </Button>}
    </nav>;
}